import script from "./FilterTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterTabs.vue?vue&type=script&setup=true&lang=js"

import "./FilterTabs.vue?vue&type=style&index=0&id=7162fe5b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7162fe5b"]])

export default __exports__